<mat-form-field class="zef-input-small zef-input-rounded" [class.zef-input-space]="space">
  <mat-icon matPrefix>action_find</mat-icon>
  <input #inputField matInput autocomplete="off" [placeholder]="placeholder" [value]="value" (input)="emit($event)" />
</mat-form-field>
